import { useCallback } from 'react';
import { useOpenDeeplink } from '../../hooks';
import { isWeb } from '../isWeb';

/**
 * 외부 링크를 엽니다.
 * - 앱: ably://outlink 딥링크 사용
 * - 웹: window.open으로 새 탭에서 열기
 */
export const useOpenOutlink = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(
    (url: string) => {
      if (isWeb) {
        window.open(url, '_blank');
        return;
      }
      openDeeplink(`ably://outlink?url=${url}`);
    },
    [openDeeplink],
  );
};
